import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { parseJwt } from "../utils/JwtDecode";

export const fetchUsers = createAsyncThunk("users/all-users", async () => {
  const response = await fetch("https://joyfulserver.ddns.net:443/api/User/all-users");
  const result = await response.json();
  return result;
});

export const fetchRoles = createAsyncThunk("users/all-roles", async () => {
  const response = await fetch("https://joyfulserver.ddns.net:443/api/User/all-roles");
  const result = await response.json();
  return result;
});

export const registerUser = createAsyncThunk(
  "users/addUser",
  async (newUser) => {
    const response = await fetch("https://joyfulserver.ddns.net:443/api/Auth/register", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(newUser),
    });
    return await response.json();
  }
);

export const loginUser = createAsyncThunk(
  "auth/login",
  async (user, { rejectWithValue }) => {
    try {
      const response = await fetch("https://joyfulserver.ddns.net:443/api/Auth/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(user),
      });

      if (!response.ok) {
        throw new Error("Email və ya şifrə yanlışdır!");
      }

      const data = await response.json();
      const token = data.token;

      if (!token) {
        throw new Error("Token alınmadı!");
      }

      localStorage.setItem("token", token);
      const decoded = parseJwt(token);

      return {
        token,
        userInfo: {
          id: decoded["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"] || null,
          email: decoded.email || null,
          name: decoded["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name"] || null,
          role: decoded["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"] || null,
        },
      };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const assignRoleToUser = createAsyncThunk(
  "users/assign-role",
  async ({ userId, roleId }) => {
    const response = await fetch(
      "https://joyfulserver.ddns.net:443/api/User/assign-role",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ userId, roleId }),
      }
    );
  }
);

export const deleteUser = createAsyncThunk(
  "users/delete-user",
  async ({ userId, roleId }) => {
    const response = await fetch(
      "https://joyfulserver.ddns.net:443/api/User/assign-role",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ userId, roleId }),
      }
    );
  }
);

const usersSlice = createSlice({
  name: "users",
  initialState: {
    users: [],
    roles: [],
    selectedUser: null,
    userInfo:null,
    token: "",
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUsers.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchUsers.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.users = action.payload;
      })
      .addCase(fetchUsers.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(fetchRoles.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchRoles.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.roles = action.payload;
      })
      .addCase(fetchRoles.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(registerUser.fulfilled, (state, action) => {
        if (action.payload) {
          state.users = [...state.users, action.payload];
        }
      })

      .addCase(loginUser.fulfilled, (state, action) => {
        console.log("User Info:", action.payload.userInfo);
        state.token = action.payload.token;
        state.userInfo = action.payload.userInfo;
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(assignRoleToUser.fulfilled, (state, action) => {
        const { userId, roleId } = action.meta.arg;
        const user = state.users.find((u) => u.id === userId);
        if (user) {
          if (!user.UserOperationClaims) {
            user.UserOperationClaims = [];
          }
          user.UserOperationClaims.push({ operationClaimId: roleId });
        }
      });
  },
});

export default usersSlice.reducer;
